<template>
  <div style="display: flex; align-items: flex-start">
    <sidebar style="margin-right: 20px; max-width: 200px"/>
    <el-card style="width: 100%">
      <div
        slot="header"
        class="clearfix"
      >
        <span>Todo kezelő</span>
        <el-button
          v-can="'todo.create'"
          style="float: right; margin-top: -5px;"
          type="success"
          size="small"
          icon="el-icon-plus"
          @click="$router.replace('/todos/add')"
        >
          Új todo
        </el-button>
      </div>
      <table-filter
        v-if="config"
        :config="config"
        action="todo/fetchAll"
      />
      <list/>
      <template v-if="$route.meta.showViewTodoDialog">
        <TodoViewDialog
          :todo-id="$route.params.id"
        />
      </template>
      <template v-if="$route.meta.showAddTodoDialog">
        <todo-dialog
          type="add"
        />
      </template>
      <template v-if="$route.meta.showUpdateTodoDialog">
        <todo-dialog
          :todo-id="$route.params.id"
          type="update"
        />
      </template>
    </el-card>
  </div>
</template>

<script>
import List from '../../components/todos/List';
import TodoDialog from '../../components/todos/Dialog';
import TodoViewDialog from '../../components/todos/View';
import TableFilter from '../../components/TableFilter';
import Sidebar from '../../components/todos/Sidebar';

export default {
  components: {
    List,
    TodoDialog,
    TodoViewDialog,
    TableFilter,
    Sidebar,
  },
  data() {
    return {
      config: null,
    };
  },
  async mounted() {
    await this.setConfig();
  },
  methods: {
    async setConfig() {
      let users = this.$store.getters['user/users'];
      if (!users.length) {
        await this.$store.dispatch('user/fetchAll');
        users = this.$store.getters['user/users'];
      }
      this.config = [
        {
          type: 'select',
          options: users,
          name: 'responsible_user_id',
          label: 'Felelős',
          labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
          valueKey: 'id',
        },
        {
          type: 'text',
          name: 'title',
          label: 'Cím',
          defaultSearch: true
        },
        {
          type: 'text',
          name: 'description',
          label: 'Leírás',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Kész',
              status: 'done'
            },
            {
              label: 'Folyamatban',
              status: 'in-progress'
            },
            {
              label: 'Elintézendő',
              status: 'todo'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        {
          type: 'select',
          name: 'creator_user_id',
          options: users,
          label: 'Létrehozó',
          labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
          valueKey: 'id',
        },
        {
          type: 'select',
          name: 'subscriber',
          options: users,
          label: 'Feliratkozó',
          labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
          valueKey: 'id',
        },
      ];
    }
  },
};
</script>
